import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RegularCollectionPointFiltering, RegularCollectionPointAddEdit } from './Pages';

export const RegularCollectionPointRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={RegularCollectionPointFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={RegularCollectionPointAddEdit} />
    </Fragment>
)